import { render, staticRenderFns } from "./ComprehensionMultiple.vue?vue&type=template&id=23bf577c&"
import script from "./ComprehensionMultiple.vue?vue&type=script&lang=js&"
export * from "./ComprehensionMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports